/* Shared solar page behavior. Only the explicitly marked local form is a demo. */
(() => {
  const root = document.querySelector('.solar-world');
  if (!root) return;
  const tabs = [...root.querySelectorAll('[data-solar-tab]')];
  const chooseTab = (name, focus = false) => {
    tabs.forEach(tab => {
      const active = tab.dataset.solarTab === name;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
      if (active && focus) tab.focus();
    });
  };
  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => chooseTab(tab.dataset.solarTab));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); chooseTab(tabs[next].dataset.solarTab, true); }
    });
  });
  const form = root.querySelector('.solar-form');
  if (!form) return;
  const previewNote = form.querySelector('[data-solar-preview-note]');
  if (previewNote) previewNote.hidden = window.Shopify?.theme?.role === 'main' &&
    !window.Shopify?.designMode && !new URLSearchParams(window.location.search).has('preview_theme_id');
  const packageField = form.querySelector('[data-solar-package-field]');
  const contextField = form.querySelector('[data-solar-context-field]');
  const packages = { hybrid: 'Solar + Storage', 'solar-only': 'Solar Array' };
  // Native product identity owns the purchase price and variant. An inquiry can
  // discuss a different package without changing the product being purchased.
  const nativeProduct = root.dataset.solarNativeProduct === 'true';
  const productPackage = root.dataset.solarInitialPackage;
  let packageCopy = {};
  try { packageCopy = JSON.parse(root.querySelector('[data-solar-package-copy]')?.textContent || '{}'); } catch { /* Keep the server-rendered copy. */ }
  const choosePackage = value => {
    if (packageField) packageField.value = value;
    const key = Object.keys(packages).find(key => packages[key] === value);
    const copy = packageCopy[nativeProduct ? productPackage : key];
    if (copy) {
      root.querySelectorAll('[data-solar-hero]').forEach(node => {
        // Authored static package copy only; no form value or URL text is inserted as HTML.
        if (Object.prototype.hasOwnProperty.call(copy, node.dataset.solarHero)) node.innerHTML = copy[node.dataset.solarHero];
      });
      const cta = root.querySelector('[data-solar-hero-cta]');
      if (cta) cta.dataset.solarPackage = nativeProduct ? packages[productPackage] : value;
    }
    root.querySelectorAll('[data-solar-offer]').forEach(card => {
      const selected = nativeProduct ? card.dataset.solarOffer === productPackage : packages[card.dataset.solarOffer] === value;
      card.dataset.solarSelected = String(selected);
      if (selected) card.setAttribute('aria-current', 'true');
      else card.removeAttribute('aria-current');
      const note = card.querySelector('[data-solar-selected-note]');
      if (note) note.hidden = !selected;
    });
  };
  root.querySelectorAll('[data-solar-package], [data-solar-context]').forEach(link => {
    link.addEventListener('click', () => {
      if (link.dataset.solarPackage) choosePackage(link.dataset.solarPackage);
      if (link.dataset.solarContext && contextField) contextField.value = link.dataset.solarContext;
    });
  });
  if (packageField) packageField.addEventListener('change', () => choosePackage(packageField.value));
  const query = new URLSearchParams(window.location.search);
  const application = query.get('application');
  const serverState = form.querySelector('[data-solar-server-status]')?.dataset.solarServerStatus;
  const canPrefill = !serverState || serverState === 'ready';
  if (canPrefill && packages[root.dataset.solarInitialPackage]) choosePackage(packages[root.dataset.solarInitialPackage]);
  if (['commercial', 'property', 'trade'].includes(application)) {
    chooseTab(application);
    if (canPrefill && contextField) contextField.value = {
      commercial: 'Commercial / agriculture', property: 'Lodge / rural property', trade: 'Installer / power business'
    }[application];
    if (canPrefill && application === 'trade' && !nativeProduct) choosePackage(packages['solar-only']);
  }
  const requestedPackage = !nativeProduct || query.get('package') === productPackage ? packages[query.get('package')] : undefined;
  if (canPrefill && requestedPackage) choosePackage(requestedPackage);
  else if (packageField) choosePackage(packageField.value);

  // Shopify contact forms post normally and use Liquid's server confirmation.
  if (form.dataset.reviewOnly !== 'true') {
    form.querySelector('[data-solar-form-result]')?.focus();
    return;
  }
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const result = root.querySelector('#solar-inquiry-result');
    result.replaceChildren();
    const title = document.createElement('strong');
    title.textContent = 'Your inquiry preview is ready. Nothing was sent.';
    result.append(title);
    const context = document.createElement('p');
    context.textContent = `${packageField.value} · ${contextField.value} · ${form.elements.location.value}`;
    result.append(context);
    const message = document.createElement('p');
    message.textContent = 'In the live journey, House of Koval would review these details and follow up about your equipment needs and next steps. This preview does not save personal details or send a message.';
    result.append(message);
    result.hidden = false;
    result.focus();
  });
})();
